// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_menuAbsoluteBox__znP3X {
    position: absolute;
    box-sizing: border-box;

    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;


  
    /* background: #ffffff; */

    box-sizing: border-box;
    box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.09);
    border-radius: 4px;
    left: 10px;
    right:unset;
    bottom:100%;
    z-index: 3899;
    padding: 0 10px;
  }

  .styles_themeLeft__Ntr2r{left:10px;right:unset}
  .styles_themeLeftLtr__yfExH{
    right:10px;
    left:unset;
  }

  /* .langLeft{left:30px;}
  .themeLangLtr{
    left:-100px;
  } */

  .styles_boxWidth__wtiZz{
    width:150px !important;
  }

  .styles_sendButton__QUkGT{
    background-color: unset!important;
    border:unset !important;
    display:flex;
    justify-content: center;
    align-items:center;
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

.styles_fileUpload__dXtH5{

    /* display:flex;
    justify-content: center;
    align-items:center;
    background-color: #fff;
    height:44px;
    width:44px; */
  }
  .styles_fileUpload__dXtH5 input[type="file"] {
    display: none;
  }
  .styles_fileButton__qLdOF{
    display:flex;
    justify-content: center;
    align-items:center;
    background-color: #fff;
    height:44px;
    width:44px;
    position:relative;
    border-radius:50%;
    margin:5px;
    cursor:pointer;

  }
  .styles_fileContentAbsoluteRtl__zlLFP{
    box-sizing: border-box;
    bottom:100% !important;
    position: absolute;
    left:0px;
    padding:10px;
    z-index: 100;
  }
  .styles_fileContentAbsoluteLtr__vgeW3{
    box-sizing: border-box;
    bottom:100% !important;
    position: absolute;
    right:0px;
    padding:10px;
    z-index: 100;
  }`, "",{"version":3,"sources":["webpack://./../src/renderer/components/FileButton/styles.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,sBAAsB;;IAEtB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;;;;IAIvB,yBAAyB;;IAEzB,sBAAsB;IACtB,2CAA2C;IAC3C,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;EAEA,yBAAW,SAAS,CAAC,WAAW;EAChC;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;;;KAGG;;EAEH;IACE,sBAAsB;EACxB;;EAEA;IACE,iCAAiC;IACjC,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;AAEF;;IAEI;;;;;iBAKa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,cAAc;;EAEhB;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;EACd","sourcesContent":[".menuAbsoluteBox {\n    position: absolute;\n    box-sizing: border-box;\n\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n\n\n  \n    /* background: #ffffff; */\n\n    box-sizing: border-box;\n    box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.09);\n    border-radius: 4px;\n    left: 10px;\n    right:unset;\n    bottom:100%;\n    z-index: 3899;\n    padding: 0 10px;\n  }\n\n  .themeLeft{left:10px;right:unset}\n  .themeLeftLtr{\n    right:10px;\n    left:unset;\n  }\n\n  /* .langLeft{left:30px;}\n  .themeLangLtr{\n    left:-100px;\n  } */\n\n  .boxWidth{\n    width:150px !important;\n  }\n\n  .sendButton{\n    background-color: unset!important;\n    border:unset !important;\n    display:flex;\n    justify-content: center;\n    align-items:center;\n    color: #000;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n\n.fileUpload{\n\n    /* display:flex;\n    justify-content: center;\n    align-items:center;\n    background-color: #fff;\n    height:44px;\n    width:44px; */\n  }\n  .fileUpload input[type=\"file\"] {\n    display: none;\n  }\n  .fileButton{\n    display:flex;\n    justify-content: center;\n    align-items:center;\n    background-color: #fff;\n    height:44px;\n    width:44px;\n    position:relative;\n    border-radius:50%;\n    margin:5px;\n    cursor:pointer;\n\n  }\n  .fileContentAbsoluteRtl{\n    box-sizing: border-box;\n    bottom:100% !important;\n    position: absolute;\n    left:0px;\n    padding:10px;\n    z-index: 100;\n  }\n  .fileContentAbsoluteLtr{\n    box-sizing: border-box;\n    bottom:100% !important;\n    position: absolute;\n    right:0px;\n    padding:10px;\n    z-index: 100;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuAbsoluteBox": `styles_menuAbsoluteBox__znP3X`,
	"themeLeft": `styles_themeLeft__Ntr2r`,
	"themeLeftLtr": `styles_themeLeftLtr__yfExH`,
	"boxWidth": `styles_boxWidth__wtiZz`,
	"sendButton": `styles_sendButton__QUkGT`,
	"fileUpload": `styles_fileUpload__dXtH5`,
	"fileButton": `styles_fileButton__qLdOF`,
	"fileContentAbsoluteRtl": `styles_fileContentAbsoluteRtl__zlLFP`,
	"fileContentAbsoluteLtr": `styles_fileContentAbsoluteLtr__vgeW3`
};
export default ___CSS_LOADER_EXPORT___;
